import { useTranslation } from "react-i18next";
import Group from "assets/images/group.png";
import "./index.scss";
// import { getRefreshTokenCookie } from "lib/Storage";
import ArrowIcon from "assets/images/arrowIcon.png";
import useInputKeys from "hooks/useInputKeys";

const Setting = ({ setTab }) => {
  const { t } = useTranslation();
  const { userInfo } = useInputKeys();

  // const goToUploadPage = () => {
  //   const token = getRefreshTokenCookie();
  //   const baseUrl = window.location.origin;
  //   window.location.replace(
  //     `http://localhost:3000/?token=${token}&source=${baseUrl}`
  //   );
  // };

  return (
    <div className="setting-component-wrapper">
      <div
        className="profile"
        onClick={() => {
          setTab("profile");
        }}
      >
        <div className="group-icon">
          {userInfo?.hasAvatar ? (
            <img
              src={`https://fs.zharfabeen.com/onacademyp/${userInfo.username}`}
              alt=""
            />
          ) : (
            <img src={Group} alt="" />
          )}
        </div>
        <div
          //  onClick={goToUploadPage}
          className="box-name"
        >
          {userInfo?.cardName}
        </div>
        <div className="box-edit">
          <img src={ArrowIcon} alt="" />
        </div>
      </div>
      <div
        className="box-shadow"
        onClick={() => {
          setTab("theme");
        }}
      >
        {t("theme")}
      </div>
      <div
        className="box-shadow"
        onClick={() => {
          setTab("language");
        }}
      >
        {t("language")}
      </div>
    </div>
  );
};

export default Setting;
